<template>
  <div class="containar">
    <div style="float: left;width: 100%;height: 20%">
      <div id="logoDiv">
        <img src="../../../static/img/logo.png" id="logo">
      </div>
      <div id="logotextDiv">
        <span style="font-size: 20px">甘肃智通科技工程检测咨询有限公司</span><br>
        <span style="font-size: 20px">Gansu ZhiTong Technology Enginnering Detection Consulting Co.,LTD</span><br>
        <span style="font-weight:bold;font-size: 30px">公路工程试验检测资产管理系统</span><br>
        <span style="font-weight:bold;font-size: 10px">MANAGEMENT SYSTEM OF HIGHWAY ENGINEERING TEST AND DETECTION
          EQUIPMENT2.0</span><br>
      </div>
    </div>
    <div id="logoimgDiv">
      <img src="../../../static/img/bg2.png" style="height: 100%;width: 100%">
    </div>
    <div id="loginFormDiv">
      <p style="text-align: left;margin-left: 15px;height: 50px;line-height: 50px;font-size: 20px">欢迎登录</p>
      <!-- 登录方式切换 -->
      <div class="login-tabs">
        <span :class="['tab', { active: loginType === 'pwd' }]" @click="loginType='pwd'">密码登录</span>
        <span :class="['tab', { active: loginType === 'sms' }]" @click="loginType='sms'">短信登录</span>
      </div>

      <!-- 密码登录 -->
      <el-form v-if="loginType === 'pwd'" :model="loginForm" :rules="checkLogin" ref="loginForm">
        <div class="inputDiv">
          <el-form-item prop="userName">
            <el-input placeholder="请输入用户名" prefix-icon="el-icon-user" class="input inputHeight" auto-complete="off"
              v-model="loginForm.userName">
            </el-input>
          </el-form-item>
        </div>
        <div style="margin-top:5%" class="inputDiv">
          <el-form-item prop="password">
            <el-input placeholder="请输入密码" prefix-icon="el-icon-lock" show-password class="input inputHeight"
              v-model="loginForm.password">
            </el-input>
          </el-form-item>
        </div>
        <div style="margin-top:5%;" class="inputDiv">
          <el-form-item prop="code">
            <el-input placeholder="验证码" auto-complete="off" v-model="loginForm.code" class="code inputHeight">
            </el-input>
            <img v-if="captchImg" class="codes" @click="getCode" :src="captchImg">
            <div v-else class="codes" style="line-height:40px;text-align:center;color:#999;background:#f5f5f5;border:1px solid #ddd;border-radius:4px;">加载中...</div>
          </el-form-item>
        </div>
        <div>
          <el-form-item>
            <el-button type="primary" style="width:80%" @click.native.prevent="confirmLogin">登录</el-button>
          </el-form-item>
        </div>
      </el-form>

      <!-- 短信登录 -->
      <div v-if="loginType === 'sms'" style="padding: 0 10px;">
        <div class="inputDiv">
          <el-input placeholder="请输入手机号" prefix-icon="el-icon-phone" class="input inputHeight"
            v-model="smsForm.phone" maxlength="11">
          </el-input>
        </div>
        <div style="margin-top:5%;" class="inputDiv sms-code-row">
          <el-input placeholder="验证码" auto-complete="off" v-model="smsForm.code" maxlength="6" class="input inputHeight">
          </el-input>
          <el-button :disabled="smsTimeNum < 60" @click="handleSendSmsCode" :loading="smsSending" class="inputHeight">
            {{ smsTimeNum < 60 ? `${smsTimeNum}s` : '获取验证码' }}
          </el-button>
        </div>
        <div style="margin-top:5%;" class="inputDiv sms-code-row">
          <el-input placeholder="图形验证码" auto-complete="off" v-model="smsCaptchaCode" maxlength="4" class="input inputHeight">
          </el-input>
          <el-image :src="smsCaptchaImg" @click="getSmsCaptcha" style="width:38%;height:40px;cursor:pointer;border-radius:4px;border:1px solid #ddd;" fit="fill"></el-image>
        </div>
        <div style="margin-top:8%;">
          <el-button type="primary" style="width:80%" @click="handleSmsLogin" :loading="smsLoading">登录</el-button>
        </div>
      </div>

      <div style="margin-top:10px;">
        <router-link to="/dingDing" class="dingding">
          <span style="vertical-align: middle;">其他方式登录</span>
          <img src="../../../static/img/dingding.png" style="vertical-align: middle;">
        </router-link>
        <router-link to="/passwordForget" class="passwordForget"><span
            style="margin-left: 13%;"><a>忘记密码？</a></span></router-link>
      </div>
    </div>
    <FooterBar />
  </div>
</template>

<script>
import { getCodes, login, myTranslate, sendLoginSms, loginBySms } from '../../api/api';
import { mapMutations } from 'vuex';
import axios from 'axios';
import { base } from '../../api/api';
import FooterBar from '../../components/FooterBar';

export default {
  components: { FooterBar },
  name: "Login",
  data() {
    return {
      loginType: 'pwd',   // pwd | sms
      loginForm: {
        userName: '',
        password: '',
        code: ''
      },
      checkLogin: {
        userName: { required: true, message: '请输入账号', trigger: 'blur' },
        password: { required: true, message: '请输入密码', trigger: 'blur' },
        code: { required: true, message: '请输入验证码', trigger: 'blur' }
      },
      smsForm: {
        phone: '',
        code: ''
      },
      smsSending: false,
      smsLoading: false,
      smsTimeNum: 60,
      smsTimer: null,
      smsCaptchaImg: "",
      smsCaptchaCode: "",
      identifyCodes: "1234567890",
      identifyCode: "",
      checked: true,
      captchImg: null,
      userToken: 0,
    }
  },
  mounted() {
    this.getCode();
  },
  watch: {
    loginType(val) {
      if (val === 'sms') {
        this.$nextTick(() => this.getSmsCaptcha());
      }
    }
  },
  created() {
    const that = this
    document.onkeydown = function (e) {
      var key = window.event.keyCode;
      if (key == 13) {
        console.log("enter");
        if (that.loginType === 'sms') {
          that.handleSmsLogin()
        } else {
          that.confirmLogin()
        }
      }
    }
  },
  beforeDestroy() {
    if (this._captchaUrl) {
      URL.revokeObjectURL(this._captchaUrl);
    }
    if (this.smsTimer) {
      clearInterval(this.smsTimer);
    }
  },
  methods: {
    ...mapMutations(['changeLogin']),
    // === 密码登录 ===
    getCode() {
      this.captchImg = null;
      axios.get(`${base}/user/code`, {
        responseType: 'blob',
        params: { _t: Date.now() + '_' + Math.random().toString(36).slice(2) }
      }).then(response => {
        if (this._captchaUrl) {
          URL.revokeObjectURL(this._captchaUrl);
        }
        this._captchaUrl = URL.createObjectURL(response.data);
        this.captchImg = this._captchaUrl;
      }).catch(() => {
        this.captchImg = getCodes({});
      });
    },
    confirmLogin() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          login(this.loginForm).then(datas => {
            let { status, message, data } = datas
            if (status == 400) {
              this.$message({ message: message, type: 'error' });
              this.getCode();
            } else if (status == 200) {
              this.afterLogin(data);
            } else {
              this.$message({ message: "请求错误", type: 'error' });
              this.getCode();
            }
          });
        }
      })
    },

    // === 短信登录 ===
    handleSendSmsCode() {
      const phone = this.smsForm.phone;
      if (!phone) {
        this.$message({ message: '请输入手机号', type: 'warning' });
        return;
      }
      if (!/^1[3-9]\d{9}$/.test(phone)) {
        this.$message({ message: '请输入正确的手机号', type: 'warning' });
        return;
      }
      if (!this.smsCaptchaCode) {
        this.$message({ message: '请输入图形验证码', type: 'warning' });
        return;
      }
      if (this.smsTimeNum < 60) return;
      this.smsSending = true;
      sendLoginSms({ phone, verifyCode: this.smsCaptchaCode }).then(res => {
        if (res.status == 200) {
          this.$message({ message: '验证码已发送', type: 'success' });
          this.smsCaptchaCode = '';
          this.getSmsCaptcha();
          this.smsTimeNum = 59;
          this.smsTimer = setInterval(() => {
            this.smsTimeNum--;
            if (this.smsTimeNum <= 0) {
              this.smsTimeNum = 60;
              this.smsSending = false;
              clearInterval(this.smsTimer);
              this.smsTimer = null;
            }
          }, 1000);
        } else {
          this.$message({ message: res.message || '发送失败', type: 'warning' });
          this.smsCaptchaCode = '';
          this.getSmsCaptcha();
          this.smsSending = false;
        }
      }).catch(() => {
        this.$message({ message: '发送失败，请重试', type: 'error' });
        this.smsSending = false;
        this.getSmsCaptcha();
      });
    },
    getSmsCaptcha() {
      this.smsCaptchaImg = '';
      axios.get(`${base}/user/code`, {
        responseType: 'blob',
        params: { _t: Date.now() + '_' + Math.random().toString(36).slice(2) }
      }).then(response => {
        const url = URL.createObjectURL(response.data);
        this.smsCaptchaImg = url;
      }).catch(() => {
        this.smsCaptchaImg = '';
      });
    },
    handleSmsLogin() {
      if (!this.smsForm.phone) {
        this.$message({ message: '请输入手机号', type: 'warning' });
        return;
      }
      if (!this.smsForm.code) {
        this.$message({ message: '请输入验证码', type: 'warning' });
        return;
      }
      this.smsLoading = true;
      loginBySms({ phone: this.smsForm.phone, code: this.smsForm.code }).then(res => {
        if (res.status == 200) {
          this.afterLogin(res.data);
        } else {
          this.$message({ message: res.message || '登录失败', type: 'error' });
          this.smsLoading = false;
        }
      }).catch(() => {
        this.$message({ message: '请求失败，请重试', type: 'error' });
        this.smsLoading = false;
      });
    },

    // === 登录成功后处理 ===
    afterLogin(data) {
      // 正常登录一律清除「模拟登录」残留标记
      // （否则上次模拟后未点退出登录就重新登录，会被 Home.vue 误判为仍在模拟状态）
      localStorage.removeItem("impersonating");
      if (data.skin == "theme") {
        localStorage.setItem("theme", "#23345e")
        localStorage.setItem("header", "#255F9E")
      } else {
        localStorage.setItem("theme", "#0680c7")
        localStorage.setItem("header", "#10a1d2")
      }
      localStorage.setItem("loading", false)
      localStorage.setItem('user', JSON.stringify(data));
      this.$message({ message: '登录成功', type: 'success' });
      this.userToken = new Date().getTime();
      this.changeLogin({ token: this.userToken });
      if (data && data.userId) {
        myTranslate({ userId: data.userId }).then(res => {
          if (res.status === 200 && Array.isArray(res.data)) {
            this.$root.badgeValue = res.data.length;
          }
        });
      }
      // 检查是否需要强制修改初始密码
      if (data.pwdChanged === 0 || data.pwdChanged === '0') {
        setTimeout(() => {
          this.$router.push({ path: "/forceChangePwd" });
        }, 1500)
        return;
      }
      setTimeout(() => {
        this.$router.push({
          path: "/DeviceInfo",
          name: "设备信息",
          title: "设备信息"
        });
      }, 1500)
    }
  }
}
</script>

<style scoped>
body {
  margin: 0px;
  padding: 0px;
  font-size: 14px;
  -webkit-font-smoothing: antialiased;
}

.containar {
  top: 0px;
  left: 0px;
  height: 100vh;
  width: 100vw;
  background-color: #255F9E;
  caret-color: transparent;
  user-select: none;
}

#logoDiv { width: 90px; height: 90px; margin-left: 15px; }
#logo { width: 100%; height: 100%; }
#logotextDiv {
  position: absolute; left: 120px; top: 1%; width: 700px; height: 10%;
  text-align: left; color: white;
}
#logoimgDiv { width: 40%; height: 73%; }

#loginFormDiv {
  position: relative; left: 65%; bottom: 45%; background-color: white;
  border-radius: 5%; width: 350px;
  padding-bottom: 20px;
  user-select: text; caret-color: auto;
}

.input { width: 100%; }
.inputDiv { width: 80%; margin: 0px auto; }
.inputHeight { height: 40px !important; }
.inputHeight ::v-deep .el-input__inner {
  height: 40px;
  line-height: normal;
}

.code { width: 50%; margin-left: -50%; }
.codes {
  position: absolute; width: 40%; top: -5%; left: 55%;
}

.passwordForget { color: black; text-decoration: none; }
.dingding { color: black; text-decoration: none; }

/* 登录方式切换tab */
.login-tabs {
  display: flex;
  justify-content: center;
  margin-bottom: 15px;
  border-bottom: 1px solid #eee;
}
.login-tabs .tab {
  padding: 8px 30px;
  cursor: pointer;
  color: #999;
  font-size: 14px;
  border-bottom: 2px solid transparent;
  transition: all 0.2s;
}
.login-tabs .tab.active {
  color: #409EFF;
  border-bottom-color: #409EFF;
}

/* 短信验证码行 */
.sms-code-row {
  display: flex;
  gap: 8px;
}
.sms-code-row .el-input {
  flex: 1;
}
.sms-code-row .el-button {
  flex-shrink: 0;
  font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// src/views/users/Login.vue